module.exports = __webpack_public_path__ + "img/user.87128429.svg";